//*react- recursos
import React, { useEffect } from "react";

//*css


//*archivos
import tuplacatalogo from "../stores/tuplacatalogoStore";

//*interfaces
interface PropsTC{
  tupla:any;
}

//*componente
export default function ConvierteTuplaACatalogo(props: PropsTC){

  const { setTuplaCatalogo } =
    tuplacatalogo((state:any) =>( {
      setTuplaCatalogo: state.setTuplaCatalogo,
  }));
 
  useEffect(()=>{
    let keysT= Object.keys(props.tupla);
    let catalogoTemp:any=[];
    keysT.map((kt:any)=>{
       let cat:any={};
       cat = { "id":kt, "desc": props.tupla[kt] };
       catalogoTemp.push(cat);
    })
    setTuplaCatalogo(catalogoTemp);
    console.clear();
    console.log("** ConvierteTuplaACatalogo **")
    console.log("tupla de entrada: ", props.tupla); 
    console.log("catalogo de salida: ", catalogoTemp);
  },[]); 
   
  return (
       <div>
           <label >
               *Consulte la consola
           </label>
            
       </div>

  )
}
